import { SitemapNode } from "@salaxy/core";

/** Sitemap for the Palkkaus.fi personal web site (Household and Worker) */
export class PersonalWebSiteMap {
  /** The sitemap */
  public static sitemap: SitemapNode[] = [
    {
      title: "SALAXY.NG1_Sitemap.personalWeb.home",
      url: "#/",
      id: "home",
      isFullWidth: true,
      cssClass: "double-sidebar",
    },
    {
      title: "SALAXY.NG1_Sitemap.personalWeb.taxcards",
      url: "#/taxcards",
      id: "taxcards",
    },
    {
      title: "SALAXY.NG1_Sitemap.personalWeb.calculations.main",
      url: "#/calc",
      id: "calc",
      children: [
        {
          title: "SALAXY.NG1_Sitemap.personalWeb.calculations.paid",
          url: "#/calc/paid",
        },
        {
          title: "SALAXY.NG1_Sitemap.personalWeb.calculations.sent",
          url: "#/calc/sent",
        },
        {
          title: "SALAXY.NG1_Sitemap.personalWeb.calculations.draft",
          url: "#/calc/draft",
        },
        {
          title: "SALAXY.NG1_Sitemap.personalWeb.calculations.error",
          url: "#/calc/error",
          id: "error",
        },
        {
          title: "SALAXY.NG1_Sitemap.personalWeb.calculations.new",
          url: "#/calc/details/new",
          id: "new",
          visibility: "hidden",
        },
        {
          title: "SALAXY.NG1_Sitemap.personalWeb.calculations.calc",
          url: "#/calc/details/*",
          id: "calc",
          visibility: "hidden",
        },
        {
          title: "SALAXY.NG1_Sitemap.personalWeb.calculations.share",
          url: "#/calc/sharing/*",
          id: "calcSharing",
          visibility: "hidden",
        },
      ],
    },
    {
      title:"Työnantajat",
      url:"#/employers",
      id:"employers",
      roles:"test"
    },
    {
      title: "SALAXY.NG1_Sitemap.personalWeb.archive.main",
      url: "#/archive/worker-report",
      id: "archive",
      children: [
        {
          title: "SALAXY.NG1_Sitemap.personalWeb.archive.workerReport",
          url: "#/archive/worker-report",
        },
        {
          title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.main",
          url: "#/archive/employer-archive",
          id: "employer-archive",
          children: [
            {
              title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.employerPaid",
              url: "#/archive/employer-paid",
            },
            {
              title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.employerReport",
              url: "#/archive/employer-report",
            },
            {
              title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.householdYears.main",
              url: "#/household-years/active",
              id: "householdYears",
              children: [
                {
                  title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.householdYears.details",
                  url: "#/household-years/details/*",
                  visibility: "hidden",
                  id: "details",
                },
              ],
            },
            {
              title: "SALAXY.NG1_Sitemap.personalWeb.archive.householdDeductionReport",
              url: "#/archive/household-deduction-report",
              id: "householdDeductionReport",
              visibility: "hidden",
            },
          ]
        },
      ]
    },
    {
      title: "SALAXY.NG1_Sitemap.personalWeb.account",
      url: "#/account",
      id: "account",
    },
    {
      title: "SALAXY.NG1_Sitemap.personalWeb.abc",
      url: "https://help.palkkaus.fi/hc/fi",
      id: "abc",
      isFullWidth: true,
    },
  ];
}
